import React, { useEffect, useRef, useState } from "react";
import Heading from "../../Components/home/HeadingProducts";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Header from "../../Components/Header/Header";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { contact1, contact2, office, office1, office2, project1, project2, project3, project4, project5 } from "../../assets";
import HeaderOther from "../../Components/HeaderOther/HeaderOther";
import Title from "../../Components/Title/Title"; 



export const allProducts = [
  {
    id:1,
    image1: office1,
    image2: office2,
    image3: office1,
    image4: office2,
    room: 3,
    field: 90 

  },
  {
    id:2,
    image1: office1,
    image2: office2,
    image3: office1,
    image4: office2,
    room: 4,
    field: 130 

  },

    {
    id:3,
    image1: office1,
    image2: office2,
    image3: office1,
    image4: office2,
    room: 3,
    field: 100 

  },
  {
    id:4,
    image1: office1,
    image2: office2,
    image3: office1,
    image4: office2,
    room: 4,
    field: 100 

  },

    {
    id:5,
    image1: office1,
    image2: office2,
    image3: office1,
    image4: office2,
    room: 2,
    field: 70 

  },
  {
    id:6,
    image1: office1,
    image2: office2,
    image3: office1,
    image4: office2,
    room: 1,
    field: 27 

  },

    {
    id:7,
    image1: office1,
    image2: office2,
    image3: office1,
    image4: office2,
    room: 2,
    field: 67 

  },
  {
    id:8,
    image1: office1,
    image2: office2,
    image3: office1,
    image4: office2,
    room: 2,
    field: 55

  },

  

];
  



export default function ProductDetail() {

    
 
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(true)
  const { id } = useParams();
  const [selectedTab, setSelectedTab] = useState('description');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeModalIndex, setActiveModalIndex] = useState(0);
  
  const [products, setProducts] = useState([]);
  const [others, setOthers] = useState([]);
  const navigate = useNavigate()
  const swiperRef = useRef(null); // Swiper referansı
  const [activeIndex, setActiveIndex] = useState(0); // Aktif slide index
  const [modalImage, setModalImage] = useState(null);




  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
   
        const filteredProducts = allProducts.filter(product => product.id == id);
        const remainingProducts = allProducts.filter(product => product.id != id);
  
  // id'ye eşit olmayan ürünlerden ilk 4'ünü alıyoruz
       const filteredProducts2 = remainingProducts.slice(0, 4);

        setProducts(filteredProducts[0]); 
        setOthers(filteredProducts2);
        setIsLoading(false)
    
  };

  const slides = [];
  if (products) {
    for (let i = 1; i <= 10; i++) {
      const imgUrl = products[`image${i}`];
      if (imgUrl) {
        slides.push({ img: `${imgUrl}` });
      }
    }
  }

  const getThumbnails = () => {
    const len = slides.length;
    return [
      slides[(activeIndex - 1 + len) % len], // Soldaki fotoğraf
      slides[activeIndex], // Aktif fotoğraf
      slides[(activeIndex + 1) % len], // Sağdaki fotoğraf
    ];
  };

  if (isLoading) {
    return <div>Loading...</div>; // Veriler yüklenirken bir loading göstergesi
  }
 











// Modal'ı açma fonksiyonu
const openModal = (index) => {
  setActiveModalIndex(index);
  setIsModalOpen(true);
};

// Modal'ı kapama fonksiyonu
const closeModal = () => {
  setIsModalOpen(false);
};

// Resim değiştirme fonksiyonu
const changeImage = (direction) => {
  setActiveModalIndex((prevIndex) => {
    const newIndex = (prevIndex + direction + slides.length) % slides.length;
    return newIndex;
  });
};
  return (
    <>
    {console.log(products)}
       <HeaderOther/>
       <Title title="Ofislər"/>
       <div className='max-w-containerSm md:max-w-container mx-auto pt-[114px] md:pt-[230px]  '>
          <div className="mt-[40px] max-w-containerSm md:max-w-container mx-auto mb-[40px] md:mb-[132px]">
         <div className="md:flex">
         <div className="md:mr-[52px]">
    <p className="md:hidden text-[22px] md:text-[32px] font-medium md:mb-6 mb-2">{products.name}</p>
<div className=" hidden md:flex">
 <div>
 <img className="w-[569px] h-[433px]" src={office}></img>
 </div>
 <div className="grid grid-cols-2 gap-3 ml-3">
 <div>
 <img className="w-[363px] h-[210px]" src={office}></img>
 </div>
 <div>
 <img className="w-[363px] h-[210px]" src={office}></img>
 </div>


 <div>
 <img className="w-[363px] h-[210px]" src={office}></img>
 </div>
 <div>
 <img className="w-[363px] h-[210px]" src={office}></img>
 </div>
 </div>
</div>







<div className="mx-auto mb-10 md:hidden">
      {/* Slider */}
      <Swiper
        ref={swiperRef}
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        modules={[Autoplay, Pagination, Navigation]}
        className="main-slider"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="relative bg-white w-full h-[354px] rounded-xl flex items-center justify-center cursor-pointer">
              <img
                className="max-w-full max-h-full object-contain "
                src={slide.img}
                alt={`Slide ${index + 1}`}
                onClick={() => openModal(index)} // Open modal with the clicked index
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Thumbnail'lar */}
      <div className="flex justify-center mt-5 space-x-3">
        {getThumbnails().map((slide, index) => (
          <div
            key={index}
            className={`cursor-pointer border-2 ${
              index === 1 ? "border-[#264D92]" : "border-transparent"
            } rounded-lg bg-white w-[183px] h-[129px] flex items-center justify-center`}
            onClick={() =>
              swiperRef.current.swiper.slideTo(
                (activeIndex - 1 + index + slides.length) % slides.length
              )
            }
          >
            <img
              className="max-w-full max-h-full object-contain"
              src={slide.img}
              alt={`Thumbnail ${index + 1}`}
            />
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="relative">
            {/* Kapanma butonu */}
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-[#264D92] text-4xl font-bold z-20" // z-20 ile öne alıyoruz
            >
              ×
            </button>

            {/* Sabit boyutlu fotoğraf */}
            <div className="bg-white md:w-[500px] md:h-[500px] rounded-lg flex items-center justify-center relative">
              {/* Sol Ok */}
              <button
                className="absolute left-0 text-white text-4xl font-bold bg-black bg-opacity-50 px-3 py-2 z-10"
                onClick={() => changeImage(-1)} // Left arrow -1
              >
                &#60;
              </button>

              <img
                className="max-w-full max-h-full object-contain"
                src={slides[activeModalIndex]?.img}
                alt="Selected"
              />

              {/* Sağ Ok */}
              <button
                className="absolute right-0 text-white text-4xl font-bold bg-black bg-opacity-50 px-3 py-2 z-10"
                onClick={() => changeImage(1)} // Right arrow +1
              >
                &#62;
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  </div>

         </div>  
   <div className="md:flex justify-between mt-[60px]">
    <div className="md:w-[660px]">
      <p className="text-[24px] font-semibold">Detal</p>
      <div className="w-full h-[1px] bg-[#D2D2D2] my-[24px]"></div>
      <div className="flex  h-[58px]">
        <div className="mr-[110px] ">
   <p>Sahə</p>
   <p>{products.field}</p>
        </div>
        <div className="">
        <p>Otaq sayı</p>
        <p>{products.room}</p>
        </div>
      </div>
      <p className="text-[24px] font-semibold mt-10">Təsvir</p>
      <div className="w-full h-[1px] bg-[#D2D2D2] my-[24px]"></div>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec dignissim, urna nec viverra efficitur, nulla ligula tincidunt ipsum, sed condimentum libero nisl sit amet tortor. Donec at nisi eget elit efficitur finibus. Curabitur quis erat at justo consectetur iaculis. Proin eu posuere tellus.</p>
      <p className="text-[24px] font-semibold mt-[60px] mb-[24px]">Xəritədə açın</p>
      <div className="w-[full] md:w-[600px]">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d194473.18588939894!2d49.8549596!3d40.394592499999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d6bd6211cf9%3A0x343f6b5e7ae56c6b!2zQmFrxLE!5e0!3m2!1saz!2saz!4v1733916751974!5m2!1saz!2saz"
        className="w-full h-[300px] md:h-[400px]"
        style={{ border: '0' }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
    </div>
    <div className="md:w-[540px] mt-[44px] md:mt-0">
      <div className="bg-[#F6F6F6] py-[20px] px-[32px] rounded-xl">
   <p className="text-[24px] font-semibold">Əlaqə saxlayın</p>
   <div className="md:flex">
   <div className="flex mt-9 items-center mr-10"> 
      <img className="w-10 h-10" src={contact1}></img>
      <div className="ml-6">
        <p className="text-[16px] font-medium">+994 55 236 75 00</p>
      </div>
     </div>
     <div className="flex mt-9 items-center"> 
      <img className="w-10 h-10" src={contact2}></img>
      <div className="ml-6">
        <p className="text-[16px] font-medium">afcity@gmail.com</p>
      </div>
     </div>
   </div>
   <p className="text-black text-base font-normal mb-2 mt-9">Ad, soyad*</p>
 <input className="border-[#d2d2d2] border-[0.6px] rounded-lg h-10 w-full mb-7 p-2"></input>
 <p className="text-black text-base font-normal mb-2">Əlaqə nömrəsi*</p>
 <input className="border-[#d2d2d2] border-[0.6px] rounded-lg h-10 w-full mb-7 p-2"></input>
 <p className="text-black text-base font-normal mb-2">E-mail*</p>
 <input className="border-[#d2d2d2] border-[0.6px] rounded-lg h-10 w-full mb-7 p-2"></input>
 <p className="text-black text-base font-normal mb-2">Mesaj</p>
 <textarea className="border-[#d2d2d2] border-[0.6px] rounded-lg h-[114px] w-full mb-7 p-2"></textarea>
 <button className="text-base font-normal w-[148px] h-[44px] rounded-lg border bg-[#898989] text-[white]">Göndər</button>
      </div>
      
    </div>
   </div>
    </div>
    <div className="md:max-w-container max-w-containerSm mx-auto mb-[40px] md:mb-[132px]">
         <div className='flex flex-col mb-5 md:mb-10'>
         <p className='text-[24px] md:text-[40px] font-bold md:font-semibold font-barlow '>Digər <span className='font-barlow text-[#E11E26]'>Ofis Sahələri</span></p>
         </div>
        <div>
      <div className='grid grid-cols-1 md:grid-cols-4 gap-4'>
        {others.map((val, index) => { 
          const { image1, category, name, path, content, id, shortDescription} = val;
          console.log(id)
          return (
            <a key={id} href={`/offices/${id}`}>
            <div className="relative -z-50 md:w-[315px] h-[313px] rounded-[20px] border-[2px] border-[#EFEFEF]">
              <img className="rounded-t-[20px] mb-4 w-full h-[248px]" src={image1} alt={`Project ${id}`} />
              <p className='ml-3 text-[20px]'>{products.room} otaqlı <span>{products.field} m2</span></p>
            </div>
          </a>

          ); 
        })}
      </div>

        </div>
      </div>
      </div>

    </>
  );
}



























































































